import en from "./en_US.json";

export default { en };